var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [
      _vm.isShow
        ? _c(
            "div",
            {
              staticClass: "complaints_head",
              style: {
                background: "rgba(" + _vm.rgbaFn(_vm.type.color) + ",0.5)",
                padding: "9px",
              },
            },
            [
              _c("img", {
                attrs: {
                  src: _vm.dealColorFn(_vm.type.type).imgUrl,
                  align: "bottom",
                  alt: "",
                },
              }),
              _c("div", [_vm._v(_vm._s(_vm.item.bidSectionCode))]),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "complaints_cotent",
          style: {
            background: "rgba(" + _vm.rgbaFn(_vm.type.color) + ",0.2)",
            height: _vm.isShow ? "calc(100% - 36px)" : "100%",
          },
          on: { mouseenter: _vm.openBtn, mouseleave: _vm.openBtn },
        },
        [
          _c(
            "div",
            { staticClass: "content-title" },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    effect: "dark",
                    content: _vm.item.bidSectionName,
                    placement: "right",
                  },
                },
                [
                  _c("div", { staticClass: "card_texts" }, [
                    _vm._v(_vm._s(_vm.item.bidSectionName)),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "content-flex-row" },
            [
              _c("span", [_c("icon-svg", { attrs: { name: "w" } })], 1),
              _c("span", [_vm._v("预警内容")]),
              _c(
                "el-tooltip",
                {
                  staticClass: "tooltipItem",
                  attrs: {
                    effect: "dark",
                    content: _vm.item.warnContent,
                    placement: "right",
                  },
                },
                [_c("div", [_vm._v(_vm._s(_vm.item.warnContent))])]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "content-flex-row" }, [
            _c("span", [_c("icon-svg", { attrs: { name: "rt" } })], 1),
            _c("span", [_vm._v("预警条件")]),
            _c("span", [_vm._v(_vm._s(_vm.item.warnCondition))]),
          ]),
          _c("div", { staticClass: "content-flex-row" }, [
            _c("span", [_c("icon-svg", { attrs: { name: "time" } })], 1),
            _c("span", [_vm._v("预警时间")]),
            _c("span", [_vm._v(_vm._s(_vm.item.warnTime))]),
          ]),
          !_vm.isShow
            ? _c(
                "div",
                { staticClass: "btnBox" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.openDetail(_vm.item)
                        },
                      },
                    },
                    [_vm._v("查 看")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: {
                        click: function ($event) {
                          return _vm.dealDetail(_vm.item)
                        },
                      },
                    },
                    [_vm._v("忽略")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "header_img" }, [
            _vm.historyid == -1
              ? _c("img", {
                  attrs: { src: require("@/assets/images/fixed.png"), alt: "" },
                })
              : _vm._e(),
            _vm.historyid == 0
              ? _c("img", {
                  attrs: {
                    src: require("@/assets/images/status_processed.png"),
                    alt: "",
                  },
                })
              : _vm._e(),
            _vm.historyid == 1
              ? _c("img", {
                  attrs: {
                    src: require("@/assets/images/status_ignore.png"),
                    alt: "",
                  },
                })
              : _vm._e(),
          ]),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "处理意见",
            visible: _vm.dialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialogBox" },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  maxlength: "200",
                  "show-word-limit": "",
                },
                model: {
                  value: _vm.auditForm.opinion,
                  callback: function ($$v) {
                    _vm.$set(_vm.auditForm, "opinion", $$v)
                  },
                  expression: "auditForm.opinion",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-bottom": "20px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handle()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "backBtn",
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("返回")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }